import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShopSheinUsComponent } from './shop-shein-us/shop-shein-us.component';
import { StoresMainComponent } from './stores-main/stores-main.component';
import { ShopWalmartUsComponent } from './shop-walmart-us/shop-walmart-us.component';
import { ShopAmazonUsComponent } from './shop-amazon-us/shop-amazon-us.component';
import { ShopRockAutoComponent } from './shop-rockauto/shop-rockauto.component';
import { ShopMacysComponent } from './shop-macys/shop-macys.component';
import { ShopBathAndBodyComponent } from './shop-bath-and-body/shop-bath-and-body.component';
import { ShopCartersComponent } from './shop-carters/shop-carters.component';
import { ShopDicksSportingGoodsComponent } from './shop-sporting-goods/shop-sporting-goods.component';
import { ShopAmericanEagleComponent } from './shop-american-eagle/shop-american-eagle.component';
import { ShopPartGeeksComponent } from './shop-part-geeks/shop-part-geeks.component';
import { ShopCJPonyComponent } from './shop-cj-pony/shop-cj-pony.component';
import { ShopTargetComponent } from './shop-target/shop-target.component';
import { ShopJCPenneyComponent } from './shop-jc-penney/shop-jc-penney.component';
import { ShopNordStromComponent } from './shop-nordstrom/shop-nordstrom.component';
import { ShopSummitRacingsComponent } from './shop-summit-racings/shop-summit-racings.component';
import { ShopThreadUpComponent } from './shop-threadup/shop-threadup.component';
import { ShopNewEggComponent } from './shop-newegg/shop-newegg.component';
import { ShopCrateAndBarrelComponent } from './shop-crateandbarrel/shop-crateandbarrel.component';
import { ShopBodyBuildingComponent } from './shop-bodybuilding/shop-bodybuilding.component';
import { ShopNeimanMarcusComponent } from './shop-neiman-marcus/shop-neiman-marcus.component';

const routes: Routes = [
  {
    path: '',
    component: StoresMainComponent,
  },
  {
    path: 'how-to-shop-shein-us-and-ship-internationally',
    component: ShopSheinUsComponent,
  },
  {
    path: 'how-to-shop-walmart-and-ship-internationally',
    component: ShopWalmartUsComponent,
  },
  {
    path: 'how-to-shop-amazon-and-ship-internationally',
    component: ShopAmazonUsComponent,
  },
  {
    path: 'how-to-shop-rockauto-and-ship-internationally',
    component: ShopRockAutoComponent,
  },
  {
    path: 'how-to-shop-macys-and-ship-internationally',
    component: ShopMacysComponent,
  },
  {
    path: 'how-to-shop-bath-and-body-works-and-ship-internationally',
    component: ShopBathAndBodyComponent,
  },
  {
    path: 'how-to-shop-carters-and-ship-internationally',
    component: ShopCartersComponent,
  },
  {
    path: 'how-to-shop-dicks-sporting-goods-and-ship-internationally',
    component: ShopDicksSportingGoodsComponent,
  },
  {
    path: 'how-to-shop-american-eagle-and-ship-internationally',
    component: ShopAmericanEagleComponent,
  },
  {
    path: 'how-to-shop-part-geeks-and-ship-internationally',
    component: ShopPartGeeksComponent,
  },
  {
    path: 'how-to-shop-cj-pony-parts-and-ship-internationally',
    component: ShopCJPonyComponent,
  },
  {
    path: 'how-to-shop-target-and-ship-internationally',
    component: ShopTargetComponent,
  },
  {
    path: 'how-to-shop-jcpenney-and-ship-internationally',
    component: ShopJCPenneyComponent,
  },
  {
    path: 'how-to-shop-nordstrom-and-ship-internationally',
    component: ShopNordStromComponent,
  },
  {
    path: 'how-to-shop-summit-racing-and-ship-internationally',
    component: ShopSummitRacingsComponent,
  },
  {
    path: 'how-to-shop-thredup-and-ship-internationally',
    component: ShopThreadUpComponent,
  },
  {
    path: 'how-to-shop-newegg-and-ship-internationally',
    component: ShopNewEggComponent
  },
  {
    path: 'how-to-shop-crate-and-barrel-and-ship-internationally',
    component: ShopCrateAndBarrelComponent
  },
  {
    path: 'how-to-shop-bodybuilding-and-ship-internationally',
    component: ShopBodyBuildingComponent
  },{
    path: 'how-to-shop-neiman-marcus-and-ship-internationally',
    component: ShopNeimanMarcusComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StoresRoutingModule {}
